export const SET_SERVICE_REQUEST_DETAIL = 'SET_SERVICE_REQUEST_DETAIL'
